import { ActionableTrains } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains";
import { EventHeader } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/EventHeader";
import { InfrastructureEventSummaryPanels } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/InfrastructureEventSummaryPanels";
import { SectionBoxWithStickyHeader } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/SectionBoxWithStickyHeader";
import DecisionSupportContext from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/DecisionSupportContext";
import { AltTransStretchCoverage } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";
import { useDecisionSupportData } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/useDecisionSupportData";
import TabsCenter from "features/CenterContent/shared/Tabs/TabsCenter";
import { useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { tokens } from "shared/components/Spor";
import { SectionStateContent } from "shared/components/states/SectionStateContent";
import styled from "styled-components";

const ContentLayoutWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex: 1;
  min-height: 0;
  gap: ${tokens.default.size.spacing[2]};
  width: 100%;
`;

const ScrollableDetailsWrapper = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
`;

const DecisionSupport = () => {
  const { uuid } = useParams();

  const {
    contextValue,
    infrastructureEvent,
    infrastructureInformationStatus,
    incidentPlanLoadingState,
    relatedInfrastructureIncidentPlan,
    setShowAllStretches,
    showAllStretches,
  } = useDecisionSupportData(uuid);

  const [selectedStretch, setSelectedStretch] =
    useState<AltTransStretchCoverage | null>(null);

  const sectionState = useMemo(
    () => ({
      fetchStatus: infrastructureInformationStatus,
      isEmpty: !infrastructureEvent,
      emptyReason: "Fant ingen informasjon om hendelsen",
    }),
    [infrastructureInformationStatus, infrastructureEvent],
  );

  return (
    <>
      <TabsCenter />
      <SectionStateContent state={sectionState}>
        {infrastructureEvent && (
          <DecisionSupportContext.Provider value={contextValue}>
            <ScrollableDetailsWrapper>
              <SectionBoxWithStickyHeader
                headerContent={
                  <EventHeader
                    event={infrastructureEvent}
                    incidentPlanStatus={
                      relatedInfrastructureIncidentPlan?.event?.status
                    }
                    incidentPlanLoadingState={incidentPlanLoadingState}
                  />
                }
              >
                <ContentLayoutWrapper>
                  <InfrastructureEventSummaryPanels
                    event={infrastructureEvent}
                    selectedStretch={selectedStretch}
                    setSelectedStretch={setSelectedStretch}
                    showAllStretches={showAllStretches}
                    setShowAllStretches={setShowAllStretches}
                  />
                  <ActionableTrains event={infrastructureEvent} />
                </ContentLayoutWrapper>
              </SectionBoxWithStickyHeader>
            </ScrollableDetailsWrapper>
          </DecisionSupportContext.Provider>
        )}
      </SectionStateContent>
    </>
  );
};

export default DecisionSupport;
